import { render, staticRenderFns } from "./user-group-detail.vue?vue&type=template&id=4722eb46"
import script from "./user-group-detail.vue?vue&type=script&lang=js"
export * from "./user-group-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports